import { Tag } from "antd";

export default function StatusBox({
  status,
}: {
  /**
   * 1: Paid
   * 2: Unpaid
   * 3: Canceled
   * 4: Delivered
   */
  status: number;
}) {
  return (
    <Tag
      className={`rounded-full! py-1! px-3! text-14-regular! ${
        status === 1
          ? "text-success-500! bg-success-50! border-success-200!"
          : status === 2
            ? "text-grayscale-500! bg-grayscale-50! border-grayscale-200!"
            : status === 3
              ? "text-error-500! bg-error-50! border-error-200!"
              : "text-primary-500! bg-primary-50! border-primary-200!"
      }`}
    >
      {status === 1
        ? "پرداخت شده"
        : status === 2
          ? "پرداخت نشده"
          : status === 3
            ? "لغو شده"
            : "تحویل شده"}
    </Tag>
  );
}
